import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { useMutation } from '@tanstack/react-query';
import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeBasicInformationAddTemplate } from '../../templates';
import { InsertInitiativeDTOV3 } from '../../../store/landscapeAPI/landscape/dto/request/insert-initiative.dto';
import landscapeServiceV3 from '../../../store/landscapeAPI/landscape/services/landspace.service-v3';
import { getQueryClient } from '../../../App';
import styles from './LandscapeBasicInformationAddPage.module.css';

interface LandscapeBasicInformationAddPageProps {}

const LandscapeBasicInformationAddPage: FC<
  LandscapeBasicInformationAddPageProps
> = () => {
  const navigate = useNavigate();
  const clientQuery = getQueryClient();

  const saveLandscape = async (landscape: InsertInitiativeDTOV3) => {
    const {
      name,
      landscapeType,
      jurisdictionName,
      countryCode,
      latitude,
      longitude,
      contactPersonName,
      contactPersonRole,
      contactPersonEmail,
      isPublished,
      isLandscapeInitiative,
    } = landscape;

    const landscapeToSave = {
      name,
      landscapeType,
      jurisdictionName,
      countryCode,
      latitude,
      longitude,
      contactPersonName,
      contactPersonRole,
      contactPersonEmail,
      isPublished,
      isLandscapeInitiative,
    };

    return await landscapeServiceV3.saveLandscape(landscapeToSave);
  };

  const { mutate: handleSaveLandscape, isPending: isPendingSaveLandscape } =
    useMutation({
      mutationFn: saveLandscape,
      onSuccess: (data) => {
        clientQuery.invalidateQueries({
          queryKey: ['landscape', 'landscapes', 'name', 'asc'],
        });
        navigate(`/landscapes/edit/${data[0].id}/basic-information`);
      },
      onError: (error) => console.log(error.message),
    });

  if (isPendingSaveLandscape) {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.landscapeBasicInformationAddTemplateWrapper)}>
      <LandscapeBasicInformationAddTemplate
        // @ts-ignore
        callbackFn={handleSaveLandscape}
      />
    </div>
  );
};

export default LandscapeBasicInformationAddPage;
